export class InfoRequest {
    public Email: string;
    public Address: string;
    public Message: string;
    public RefererName: string;
    public Telephone: string;
    public City: string;
    public Where: string;
    public Company: string;
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/models/cms/info-request.ts